module.exports = __webpack_public_path__ + "static/media/Colette Curve Queen Headboard - 155 cm_Grey.984df80c.png";